import { useState } from 'react';
import { validateSubLocationActivation } from '../utils/sublocationValidations';

/**
 * Custom hook for handling sub-location status validation (archive/activate)
 * @param {Object} subLocationDetails - The sub-location details
 * @param {boolean} isActiveAssets - Whether there are active assets
 * @returns {Object} - { onStatusToggleClick, showInactiveAreaTaxModal, setShowInactiveAreaTaxModal, showWarningModal, setShowWarningModal, showArchiveModal, setShowArchiveModal }
 */
export const useSubLocationStatusValidation = (subLocationDetails, isActiveAssets) => {
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [showInactiveAreaTaxModal, setShowInactiveAreaTaxModal] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);

  const onStatusToggleClick = () => {
    if (!subLocationDetails) {
      return;
    }

    // Check for active assets first
    if (isActiveAssets && subLocationDetails.status) {
      setShowWarningModal(true);
      return;
    }

    const { status } = subLocationDetails;

    // If trying to activate (status is currently false), validate area tax location
    if (!status) {
      const validation = validateSubLocationActivation(subLocationDetails);

      if (validation.hasInactiveAreaTax) {
        // Show error modal for inactive area tax location
        setShowInactiveAreaTaxModal(true);
        return;
      }
    }

    // Validation passed, show confirmation modal
    setShowArchiveModal(true);
  };

  return {
    onStatusToggleClick,
    showInactiveAreaTaxModal,
    setShowInactiveAreaTaxModal,
    showWarningModal,
    setShowWarningModal,
    showArchiveModal,
    setShowArchiveModal,
  };
};
